/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1599
 */

var r = require(/* 86 */"./1650/86/index")
var o = require(/* 1084 */"./1753/1084")
var i = require(/* 637 */"./1598/637")
r({
  target: "Array",
  proto: true
}, {
  fill: o
})
i("fill")
